<div class="container">
  <!-- Header usando componente shared -->
  <app-page-header
    title="Obtener URL"
    subtitle="Genera la URL de first login para nuevos usuarios"
    icon="user">
  </app-page-header>

  <div class="form-alert form-alert--error" *ngIf="showAlertError">
    <i class="form-alert-icon">⚠</i>
    <span>{{ errorMessage }}</span>
  </div>
  <section class="first-login">
    <div class="form-container">
      <form class="form-wrapper" #firstLoginForm="ngForm" (ngSubmit)="onSubmit(firstLoginForm)">
          <div class="form-content">
            <div class="form-row">
              <div class="form-group">
                <label for="nit" class="form-label form-label--required">NIT</label>
                <input type="text" id="nit-input" class="form-input" 
                  [ngClass]="{'form-input--error': nitModel.invalid && nitModel.touched}"
                  placeholder="Ingresa NIT"
                  [(ngModel)]="firstLoginRequest.nit" name="nitInput" #nitModel="ngModel" required>
                <div *ngIf="nitModel.invalid && nitModel.touched" class="form-error-message">
                  <i class="form-error-icon">&#9888;</i>
                  <span class="form-error-text">Este campo es requerido!</span>
                </div>
              </div>
              <div class="form-group">
                <label for="accounts" class="form-label form-label--required">Numero Cuenta</label>
                <input type="text" id="accounts" class="form-input" 
                  [ngClass]="{'form-input--error': accounts.invalid && accounts.touched}"
                  placeholder="Ingrese numero de cuenta"
                  [(ngModel)]="firstLoginRequest.accounts" name="usernameInput" #accounts="ngModel" required>
                <div *ngIf="accounts.invalid && accounts.touched" class="form-error-message">
                  <i class="form-error-icon">&#9888;</i>
                  <span class="form-error-text">Este campo es requerido!</span>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label for="email" class="form-label form-label--required">Correo Electronico</label>
                <input type="text" id="email" class="form-input" 
                  [ngClass]="{'form-input--error': email.invalid && email.touched}"
                  placeholder="Ingresa correo electronico"
                  [(ngModel)]="firstLoginRequest.email" name="email" #email="ngModel" required>
                <div *ngIf="email.invalid && email.touched" class="form-error-message">
                  <i class="form-error-icon">&#9888;</i>
                  <span class="form-error-text">Este campo es requerido!</span>
                </div>
              </div>
              <div class="form-group"></div>
            </div>
          </div>
          <div class="form-actions">
            <button type="button" class="form-btn form-btn--cancel" (click)="cancel(firstLoginForm)"
              [ngClass]="{'is-active': firstLoginForm.valid}">Cancelar</button>
            <button type="submit" class="form-btn form-btn--submit" 
              [ngClass]="{'is-valid': firstLoginForm.valid}"
              [disabled]="firstLoginForm.invalid">Consultar</button>
          </div>
        </form>
      </div>
    </section>
    <app-confirmation-modal [isVisible]="isModalVisible"
      [confirmationText]="firtLoginUrltext" [confirmButtonText]="''" [valueToCopy]="firstLoginResponse.link" [confirmationType]="'first-login'"
      (confirmed)="onConfirm(firstLoginForm)" (canceled)="onCancel()"></app-confirmation-modal>
  </div>
  